import { Button, ButtonProps, DialogActions, styled } from '@mui/material'

const MyButton = styled(Button)(({ theme }) => ({
  minWidth: theme.spacing(14),
}))

export interface ActionsProps {
  onCancel?: ButtonProps['onClick'] // show cancel button if exists
  cancelProps?: Omit<ButtonProps, 'onClick' | 'variant'> // props for cancel button

  onAction?: ButtonProps['onClick'] // show action button if exists
  actionProps?: Omit<ButtonProps, 'onClick' | 'variant'> // props for action button

  onExtraAction?: ButtonProps['onClick'] // show action button if exists
  extraActionProps?: Omit<ButtonProps, 'onClick' | 'variant'> // props for action button

  actionText?: string
  extraActionText?: string
  cancelText?: string
}

export default function Actions({
  onCancel,
  cancelProps,
  onAction,
  actionProps,
  onExtraAction,
  extraActionProps,
  cancelText = 'いいえ',
  actionText = 'はい',
  extraActionText = 'extra',
}: ActionsProps) {
  return (
    <DialogActions sx={{ justifyContent: 'center', px: 3, py: 2 }}>
      {onCancel && (
        <MyButton
          onClick={onCancel}
          variant="outlined"
          color="secondary"
          data-testid="dialog-cancel-button"
          {...cancelProps}
        >
          {cancelText}
        </MyButton>
      )}
      {onAction && (
        <MyButton
          onClick={onAction}
          variant="contained"
          color="primary"
          disableElevation
          data-testid="dialog-action-button"
          {...actionProps}
        >
          {actionText}
        </MyButton>
      )}
      {onExtraAction && (
        <MyButton
          onClick={onExtraAction}
          variant="contained"
          color="secondary"
          disableElevation
          data-testid="dialog-extra-action-button"
          {...extraActionProps}
        >
          {extraActionText}
        </MyButton>
      )}
    </DialogActions>
  )
}
